import React from 'react'
import HomeBanner from './HomeBanner/HomeBanner'
import AboutUs from './AboutUs/AboutUs'
import Services from './Services/Services'
import Count from './Count'
import Faq from './Faq/Faq'
import Testimonial from './Testimonial/Testimonial'
import PortFolio from './PortFolio/PortFolio'
import ContactUs from './ContactUs/ContactUs'

export default function Home() {
  return (
    <>
    <HomeBanner/>
    <AboutUs/>
    <Services/>
    <Count/>
    <Faq/>
    <PortFolio/>
    <Testimonial/>
    <ContactUs/>
    </>
  )
}
